let controller = function (
	$rootScope, 
	$scope, 
	$q, 
	$timeout, 
	Process,
	Category,
	Filter,
	$ionicLoading
) {
	'ngInject'

	var vm = this;
	var productsPerPage = 10;
	var page = 1;
	var snapshot;
	var filters;
	var category;

	$scope.filtering = false;

	function promises() {
		Process.ranking().then(function(res) {
			snapshot = res;
			Filter.setActive('brands', res.brands ? res.brands.map(x => parseInt(x)) : undefined);
			Filter.setActive('filters', res.filters);
			Filter.setActive('definitions', res.definitions ? res.definitions.map(x => parseInt(x)) : undefined);
			Filter.setActive('price', res.price);
			return Category.get(snapshot.category_id)
		}).then(function(res) {
			category = res;
			return Filter.get({categories:category.id})
		}).then(function(res) {
			filters = res;
			Filter.loadInterface(filters);
			initialize();
		});
	}

	$scope.$on('$ionicView.enter', function(e, data) {

		$timeout(function() {
			Process.modals.end(false);
		}, 3000);

		promises();
	})

	function initialize() {
		page = 1;
		$scope.products = snapshot.products.slice(0, (page * productsPerPage));
		$scope.pages = Math.round((snapshot.products.length / productsPerPage) + 0.49);
	}
	
	var nextSnapshot = function (action, id, attributeId) {
		var deferred = $q.defer();
			
		$ionicLoading.show();
		
		Process.action({
			action: action, 
			value: id, 
			attribute_id: attributeId,
			price: vm.actives.price,
			filters: vm.actives.filters,
			definitions: vm.actives.definitions,
			brands: vm.actives.brands
		}).then(function(res) {
			Process.ranking().then(res => {
				snapshot = res;
				initialize();
				$ionicLoading.hide();
				$scope.filtering = false;
				deferred.resolve();
			}).catch(err => {
				$ionicLoading.hide();
				$scope.filtering = false;
				deferred.reject();
			});
		});

		return deferred.promise;
	}
	
	
	/* -- ACTION: Load more articles -- */
	$scope.nextPage = function() {
		page++;
		$scope.$emit('SCROLLPREPARE');
		
		var nextArticles = snapshot.products.slice(((page - 1) * productsPerPage), (page * productsPerPage));

		$scope.products = $scope.products.concat(nextArticles);
		
		$scope.$emit('SCROLL', 300);
		
	};

	$scope.$on('filters:changed', function(e, data) {
		vm.actives = Filter.getActives();
	});
	
	$scope.$on('filters:action', function(e, action, value, attributeId) {
		$scope.filtering = true;
		vm.actives = Filter.getActives();
		nextSnapshot(action, value, attributeId);		
	});
}

export default controller;


// WEBPACK FOOTER //
// ./app/components/ranking/ranking.controller.js